import { render, staticRenderFns } from "./AccommodationsEdit.vue?vue&type=template&id=c1a3de52&scoped=true&"
import script from "./AccommodationsEdit.vue?vue&type=script&lang=js&"
export * from "./AccommodationsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsEdit.vue?vue&type=style&index=0&id=c1a3de52&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a3de52",
  null
  
)

export default component.exports